<template lang="pug">
  table#tbCumplimiento.table.is-striped.is-responsive.is-narrow
    thead
      tr
        th(colspan=5 align="center") Cumplimiento
      tr
        th(align="center") Cliente
        th(align="center") Total entregado al {{ getTitle(fecha) }} (T.M.)
        th(align="center") % de cumplimiento respecto al total entregado
        th(align="center") Meta del Mes (T.M.)
        th(align="center") % de cumplimiento respecto a la meta mensual
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ getTitleGrupo(fecha) }}
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getTotalEntregado('P', data) | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getPorcCumpTE('P', data) }}%
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getMetaMes('P', dataMetaMensual) | numberFormatDecimal }}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getPorcCumpRM('P', data) }}%
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  Movenergy
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getTotalEntregado('M', data) | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getPorcCumpTE('M', data) }}%
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getMetaMes('M', dataMetaMensual) | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ getPorcCumpRM('M', data) }}%
      tr
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  TOTAL
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  {{ data.masaTotal | numberFormatDecimal }}
</template>

<script>
  import moment from 'moment'
import Decimal from 'decimal.js'
  
  export default {
    name: 'TbCumplimiento',
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      dataMetaMensual: {
        type: Array,
        default: () => [],
      },
      fecha: {
        type: String,
        default: '',
      },
    },
    methods: {
      getTotalEntregado(comp, cumplimientoData) {
        if (Object.keys(this.data).length > 0) {
          const verPropangol = moment(this.fecha).isBefore('2021-08-20')
          const masaProp = new Decimal(cumplimientoData.masaProp)
          const masaMov = new Decimal(cumplimientoData.masaMov)
          const masaTexMex = new Decimal(cumplimientoData.masaTexMex)
          const masaGrupo = verPropangol ? masaProp : masaTexMex
          return comp === 'P' ? masaGrupo.toFixed(2) : masaMov.toFixed(2)
        } else {
          return 0
        }
      },
      
      getPorcCumpTE(comp, cumplimientoData) {
        if (Object.keys(this.data).length > 0) {
          const verPropangol = moment(this.fecha).isBefore('2021-08-20')
          const cumplimientoGrupo = verPropangol ? cumplimientoData.porcProp : cumplimientoData.porcTexMex
          return comp === 'P' ?  cumplimientoGrupo : cumplimientoData.porcMov
        } else {
          return 0
        }
      },

      getPorcCumpRM(comp, cumplimientoData) {
        if (Object.keys(this.data).length > 0) {
          const verPropangol = moment(this.fecha).isBefore('2021-08-20')
          const cumplimientoGrupo = verPropangol ? cumplimientoData.porcPropCump : cumplimientoData.porcTexMexCump
          return comp === 'P' ? cumplimientoGrupo : cumplimientoData.porcMovCump
        } else {
          return 0
        }
      },

      getMetaMes(comp, dataMensual) {
        if (Object.keys(this.dataMetaMensual).length > 0) {
          const verPropangol = moment(this.fecha).isBefore('2021-08-20')
          const dMProp = dataMensual.find( dm => dm.compania == 1) 
          const dMMov = dataMensual.find( dm => dm.compania == 2) 
          const dMTex = dataMensual.find( dm => dm.compania == 3) 
          const dataGrupo = verPropangol ? dMProp.meta : dMTex.meta
          return comp === 'P' ? dataGrupo : dMMov.meta
        } else {
          return 0
        }
      },

      getTitle (fecha) {
        moment.locale('es-mx')
        const title = moment(fecha).format('DD [de] MMMM [del] YYYY')
        return title
      },

      getTitleGrupo (fecha) {
        const title = moment(this.fecha).isBefore('2021-08-20')
        return title ? 'Propangol' : 'TexMex'
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/dashboard/componentes/Tb_Cumplimiento.vue